import React from "react";
import { OrganizationProfile } from "@clerk/clerk-react";
import Members from "./members";
import { User2Icon } from "lucide-react";

const Organization: React.FC = () => {
  return (
    <>
      <div className="fullScreen h-full">
        <div className="container">
          <div className="savedFiltersScreen h-full pb-[75px] gap-3 mt-[20px] w-full flex justify-center items-center">
            <div className="flex-1 min-h-0 h-full flex justify-center items-center w-full">
              <OrganizationProfile
                appearance={{
                  elements: {
                    organizationProfileSidebar: { width: "250px" },
                    organizationProfileContent: {
                      padding: "0",
                      height: "100%",
                    },
                    rootBox: "w-full max-w-none",
                    organizationProfile: "w-full max-w-none",
                    cardBox: "w-full bg-white",
                    navbar: "w-full max-w-none",
                  },
                }}
              >
                <OrganizationProfile.Page
                  label="Members"
                  labelIcon={<User2Icon className="h-4 w-4" />}
                  url="members"
                >
                  <Members />
                </OrganizationProfile.Page>
              </OrganizationProfile>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Organization;
